import OfferPage from "@/mixins/offer-page";

import { DO_ENVIO_SMS } from "@/config/constants/action-types";
import { getParameterByName } from "@/utils";

jest.mock("@/utils", () => ({
  getParameterByName: jest.fn()
}));

describe("AddressData Component", () => {
  beforeEach(() => {
    Object.defineProperty(window, "location", {
      value: { href: "https://example.com" },
      writable: true
    });
    window.hash = "ABC123";
  });

  it("getURLQR", () => {
    const result = OfferPage.methods.getURLQR.call({});
    expect(result).toBe("https://example.com/#/ofertaCuenta?hash=ABC123");
  });

  it("sendSMS", () => {
    const dispatch = jest.fn();
    const context = {
      showModal: true,
      $store: { dispatch }
    };
    OfferPage.methods.sendSMS.call(context, "hola");
    expect(dispatch).toHaveBeenCalledTimes(1);
    expect(dispatch).toHaveBeenCalledWith(DO_ENVIO_SMS, "hola");
  });

  it("openModalSMS", () => {
    const context = {
      showModal: true
    };
    OfferPage.methods.openModalSMS.call(context);
    expect(context.showModal).toBe(true);
  });

  it("created", () => {
    getParameterByName.mockReturnValue("HASH");
    const dispatch = jest.fn();
    const context = {
      $store: { dispatch }
    };
    OfferPage.created.call(context);
    expect(getParameterByName).toHaveBeenCalledWith("hash");
  });
});
